import React, { useEffect, useState, useRef } from "react";
import CategoryList from "../../Products/subpages/sub_components/CategoryList";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import '../Filters.css';

const Categoryfilter = ({ setFilters, filter }) => {
    const [checkedCategories, setCheckedCategories] = useState([]);
    useEffect(() => {
    }, [filter])
    const toggle = (cat) => {
        let newcats = [...checkedCategories];
        if (checkedCategories[cat]) {
            delete newcats[cat];
            setCheckedCategories(newcats);
            setFilters((filters) => {
                const newFilters = [...filters];
                newFilters[filters.findIndex((e) => e.index == filter.index)].checkedcats = newcats;
                newFilters[filters.findIndex((e) => e.index == filter.index)].value = null;
                return newFilters
            })
        } else {
            newcats = [...checkedCategories];
            newcats[cat] = 1;
            let parts = cat.split('-');
            // parts: [listId, categoryId, headId]
            const listId = parts[0];
            const categoryId = parts[1];
            const headId = parts[2];

            // If this is a subcategory (has a headId that's not 0), also mark the parent category as checked
            if (headId && headId !== '0') {
                // Find the parent category in the provided options to determine its own headId
                const parentCat = (filter.options || []).find(o => String(o.id) === String(headId));
                const parentKey = `${listId}-${headId}-${parentCat ? (parentCat.headId || 0) : 0}`;
                newcats[parentKey] = 1;
            }

            setCheckedCategories(newcats);
            setFilters((filters) => {
                const newFilters = [...filters];
                newFilters[filters.findIndex((e) => e.index == filter.index)].checkedcats = newcats;
                newFilters[filters.findIndex((e) => e.index == filter.index)].value = categoryId ?? '';
                return newFilters
            })
        }
    }

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleOutsideClick = (e) => {
        const target = e?.target || e?.srcElement;
        if (dropdownRef.current && !dropdownRef.current.contains(target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
            document.addEventListener('touchstart', handleOutsideClick);
            document.addEventListener('click', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen]);

    const organizeCategory = (categories, parentId = null) => {
        return categories
            .filter((category) => category.headId === parentId)
            .map((category) => {
                return {
                    ...category,
                    subcategories: organizeCategory(categories, category.id),
                };
            });
    };

    const getDisplayText = () => {
        if (filter.value || filter.value === 0) {
            const found = (filter.options || []).find(o => String(o.id) === String(filter.value) || String(o.value) === String(filter.value));
            return found ? (found.name || found.title || String(filter.value)) : String(filter.value);
        }
        return 'Selecteer categorie';
    }

    return <div className="d-flex w-100 h-100">
        <div className="bg-white rounded-4 h-100 p-4 border border-gray w-100 position-relative categoryfilter-container" ref={dropdownRef}>
            <h6 className="fw-bold mb-2">{filter.name}</h6>
            <div className="input-container w-100">
                <div className={`BorderedDropDownToggle bg-white ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)} title={getDisplayText()}>
                    <span className="BorderedDropDownText">Categorie</span>
                    <FontAwesomeIcon className={`BorderedDropDownIndicator ${isOpen ? 'rotate' : ''}`} icon={faChevronDown} />
                </div>

                {isOpen && <div className={`BorderedDropDownList open show`}>
                    <div className="p-2 bg-white shadow-lg rounded-4 categoryfilter-list">
                        <CategoryList categories={organizeCategory(filter.options)} checkedCategories={filter.checkedcats} toggle={toggle} />
                    </div>
                </div>}
            </div>
        </div>
    </div>
}

export default Categoryfilter;